var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  Custom List "),_c('br'),_vm._v("\n  List.vue 를 삭제 하면, "),_c('br'),_vm._v("\n  공통으로 사용하는 목록 페이지를 사용할 수 있으며 "),_c('br'),_vm._v("\n  options.js Search.vue 를 활용 할 수 있게 된다.\n")])
}]

export { render, staticRenderFns }